export function normalizeCompanySearchTerm(input: string): string {
	const s = input.trim();
	if (!s) return s;

	// Remove separadores de máscara e converte para maiúsculas
	const normalized = s.replace(/[.\-/\s]/g, "").toUpperCase();

	// CNPJ numérico sem separadores — busca contra registros antigos com máscara
	if (/^\d{14}$/.test(normalized)) {
		return `${normalized.slice(0, 2)}.${normalized.slice(2, 5)}.${normalized.slice(5, 8)}/${normalized.slice(8, 12)}-${normalized.slice(12)}`;
	}

	// CNPJ alfanumérico sem separadores — busca contra formato normalizado no banco
	if (/^[A-Z0-9]{14}$/.test(normalized) && /[A-Z]/.test(normalized)) {
		return normalized;
	}

	return s;
}
